import api from "../globals/axios";

const FRANCHISE_STATS_ENDPOINT = "/franchise/stats/";
const FRANCHISE_FARMERS_ENDPOINT = "/franchise/farmers/";
const FRANCHISE_MY_REFERRAL_COUPON = "/franchise/my-referral-coupon/";
const GET_COUPON_USER = "/franchise/get-coupon-user/";
const MANAGED_FRANCHISES_ENDPOINT = "/franchise/managed/";
const CREATE_FRANCHISE_ENDPOINT = "/franchise/create/";

export async function getFranchiseStats() {
  const response = await api.get(FRANCHISE_STATS_ENDPOINT);
  return response.data;
}

export async function getFranchiseFarmers() {
  const response = await api.get(FRANCHISE_FARMERS_ENDPOINT);
  return response.data;
}

export async function getMyReferralCoupon() {
  const response = await api.get(FRANCHISE_MY_REFERRAL_COUPON);
  return response.data;
}

export async function getCouponUser(referralCode) {
  try {
    const response = await api.get(GET_COUPON_USER + "?coupon=" + referralCode);
    return response.data;
  } catch (error) {
    console.error("Error fetching coupon user:", error);
  }
}

/**
 * Get franchises managed by the current user
 * @returns {Promise<Array>} List of managed franchises
 */
export async function getManagedFranchises() {
  try {
    const response = await api.get(MANAGED_FRANCHISES_ENDPOINT);
    return response.data;
  } catch (error) {
    console.error("Error fetching managed franchises:", error);
    throw error;
  }
}

/**
 * Create a new franchise with the current user as account manager
 * @param {Object} franchiseData - The franchise data
 * @param {string} franchiseData.name - Name of the franchise
 * @param {number} franchiseData.basic_subscription_price - Price for basic subscription
 * @param {number} franchiseData.premium_subscription_price - Price for premium subscription
 * @param {number} franchiseData.soiltest_price - Price for soil test
 * @param {number} franchiseData.basic_subscription_incentive - Incentive for basic subscription
 * @param {number} franchiseData.premium_subscription_incentive - Incentive for premium subscription
 * @param {number} franchiseData.soiltest_incentive - Incentive for soil test
 * @param {number|null} franchiseData.bank_account - Bank account ID (optional)
 * @returns {Promise<Object>} The created franchise data
 */
export async function createFranchise(franchiseData) {
  try {
    const response = await api.post(CREATE_FRANCHISE_ENDPOINT, franchiseData);
    return response.data;
  } catch (error) {
    console.error("Error creating franchise:", error);
    throw error;
  }
}
